import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BillingComponent } from './billing/billing.component';
import { BillingFailedProvidersComponent } from './billing-failed-providers/billing-failed-providers.component';
import { BillingProcessComponent } from './billing-process/billing-process.component';
import { BillingProcessDetailsDialogComponent } from './billing-process-details-dialog/billing-process-details-dialog.component';
import { MasterBillingConceptComponent } from './billing-concept/master-billing-concept.component';
import { MasterBillingConceptModalComponent } from './billing-concept-modal/master-billing-concept-modal.component';
import { ActivityLogComponent } from './event-registry/activity-log.component';
import { BillerComponent } from './biller_provider/biller.component';
import { BillsListComponent } from './bills-list/bills-list.component';
import { BillingDownloadComponent } from './billing-download/billing-download.component';
import { ClientCodesListComponent } from './client-codes-list/client-codes-list.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'billing-failed',
                component: BillingFailedProvidersComponent,
            },
            {
                path: 'activity-log',
                component: ActivityLogComponent,
            },
            {
                path: 'biller',
                component: BillerComponent,
            },
            {
                path: 'bills-list',
                component: BillsListComponent,
            },
            {
                path: 'client-codes',
                component: ClientCodesListComponent,
            },
            {
                path: 'billing-process',
                component: BillingProcessComponent,
            },
            {
                path: 'billing',
                component: BillingComponent,
            },
            {
                path: 'billing-process-details',
                component: BillingProcessDetailsDialogComponent,
            },
            {
                path: 'master-billing',
                component: MasterBillingConceptComponent,
            },
            {
                path: 'download',
                component: BillingDownloadComponent,
            },
            {
                path: 'master-billing-modal',
                component: MasterBillingConceptModalComponent,
            },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BillingRoutingModule { }
